/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar20 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar20", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.912109 14.306641 C 12.489109 14.306641 13.544922 15.151484 13.544922 16.396484 C 13.544922 17.177484 13.085937 17.871375 11.835938 18.984375 L 10.673828 20.052734 L 10.673828 20.146484 L 13.642578 20.146484 L 13.642578 21.542969 L 8.2871094 21.542969 L 8.2871094 20.347656 L 10.513672 18.251953 C 11.548672 17.294953 11.8125 16.939437 11.8125 16.523438 C 11.8125 16.005437 11.432562 15.658203 10.851562 15.658203 C 10.246562 15.658203 9.8261719 16.069391 9.8261719 16.650391 L 9.8261719 16.683594 L 8.1835938 16.683594 L 8.1835938 16.654297 C 8.1835938 15.253297 9.2771094 14.306641 10.912109 14.306641 z M 18.822266 14.308594 C 20.634266 14.308594 21.78125 15.665766 21.78125 18.009766 C 21.78125 20.333766 20.648266 21.734375 18.822266 21.734375 C 16.991266 21.734375 15.863281 20.337906 15.863281 18.003906 C 15.863281 15.669906 17.006266 14.308594 18.822266 14.308594 z M 18.822266 15.683594 C 18.138266 15.683594 17.685547 16.455906 17.685547 18.003906 C 17.685547 19.561906 18.138266 20.357422 18.822266 20.357422 C 19.506266 20.357422 19.966797 19.561906 19.966797 18.003906 C 19.965797 16.456906 19.505266 15.683594 18.822266 15.683594 z" />
      </svg>
    );
  }
}

IconCalendar20.defaultProps = {
  className: null
};

IconCalendar20.propTypes = {
  className: PropTypes.string
};

export default IconCalendar20;
